/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Form, FormProps, Input, Space, Typography } from 'antd';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
  createTimeBannerSlider,
  setBannerTimer,
  watchTimeBanner
} from '@/redux/slices/banner.slice';
import { useEffect } from 'react';
import { Button } from '../button';

type BannerSliderModalProps = {
  onCancel: () => void;
};

type FieldType = {
  number_movement: number;
};

export const BannerSliderModal = ({ onCancel }: BannerSliderModalProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const timeBanner = useAppSelector(watchTimeBanner);

  const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
    await dispatch(createTimeBannerSlider(values));
    await dispatch(setBannerTimer(values.number_movement));

    onCancel();
  };

  useEffect(() => {
    if (timeBanner) {
      form.setFieldsValue({ number_movement: timeBanner });
    }
  }, [form, timeBanner]);

  return (
    <div>
      <Typography.Title css={titleStyles} level={4}>
        Cài đặt thời gian chuyển banner
      </Typography.Title>
      <em css={subTitle}>
        Banner slider ở Trang chủ sẽ tự động chuyển sang banner tiếp theo sau
        thời admin cài đặt. (Số giây là số nguyên và phải lớn hơn 0)
      </em>
      <div css={formStyle}>
        <Form
          form={form}
          initialValues={{ number_movement: timeBanner }}
          name='banner-slider-searcher'
          layout='horizontal'
          onFinish={onFinish}
          css={rootStyles}
        >
          <Form.Item
            label='Nhập số giây'
            name='number_movement'
            rules={[
              {
                required: true,
                message: 'Trường thông tin này không được bỏ trống'
              },
              {
                pattern: /^[1-9][0-9]*$/,
                message: 'Giá trị không hợp lệ'
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Space css={groupButtonStyles}>
              <Button
                shape='round'
                type='default'
                size='large'
                block
                onClick={onCancel}
              >
                Hủy
              </Button>
              <Button
                shape='round'
                type='primary'
                size='large'
                htmlType='submit'
                block
              >
                Cập nhật
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

const rootStyles = css`
  .ant-form-item:last-child {
    margin-bottom: 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const subTitle = css`
  font-size: 1.4rem;
  font-weight: 400;
  color: #00000080;
`;

const formStyle = css`
  margin-top: 2rem;
`;

const groupButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin-top: 1.6rem;

  .ant-space-item {
    flex: 1;
  }
`;
